import { useState, useRef } from "react";
import GetIcon from "../../../../utils/Icon";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Pagination from "../../../../Components/Pagination";

const Table = ({ row, fulldata }) => {
  const tableRef = useRef(null);

  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error");
  const [full_Item_Detail, setfull_Item_Detail] = useState({});
  const [showError, setShowError] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [columeConfModal, setcolumeConfModal] = useState(false);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);

  const [visibleColumns, setVisibleColumns] = useState([
    { name: "S.No", selected: true, key: "sno", width: "5%" },
    { name: "Item Code", selected: true, key: "item_code", width: "17%" },
    { name: "Item Name", selected: true, key: "item_name", width: "25%" },
    { name: "Qty", selected: true, key: "qty", width: "5%" },
    { name: "UOM", selected: false, key: "uom", width: "7%" },
    { name: "Rate", selected: false, key: "rate", width: "10%" },
    { name: "Amount", selected: false, key: "amount", width: "10%" },
    { name: "Reject Qty", selected: false, key: "rejected_qty", width: "80px" },
    { name: "Barcode", selected: false, key: "barcode", width: "80px" },
    { name: "Manufacturing Date", selected: false, key: "manufacturing_date", width: "80px" },
    { name: "Expiry Date", selected: false, key: "expiry_date", width: "80px" },
    { name: "Serial No.", selected: false, key: "serial_numbers", width: "70px" },
    { name: "Batch No.", selected: false, key: "batch_no", width: "70px" },
    { name: "Box Id", selected: false, key: "parent", width: "19%" },
    { name: "Settings", selected: true, key: "settings", width: "4%" },
  ]);

  if (!row || !Array.isArray(row.Rows)) return null;

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = row.Rows.slice(indexOfFirstRow, indexOfLastRow);

  const getRowColor = () => 'not-distributed';

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...row.Rows];
    updatedRows[indexOfFirstRow + index][field] = value;
    row.setRows(updatedRows);
  };

  const openEditModal = (item, index) => {
    const filterData = fulldata?.message?.items?.filter(i => i.item_code === item.item_code);
    setfull_Item_Detail(filterData?.[0] || {});
    setCurrentItem({ ...item });
    setCurrentIndex(indexOfFirstRow + index);
    setShowEditModal(true);
  };

  const saveEdit = () => {
    const updatedRows = [...row.Rows];
    updatedRows[currentIndex] = currentItem;
    row.setRows(updatedRows);
    setShowEditModal(false);
  };

  const initResize = (e, colIndex) => {
    const startX = e.clientX;
    const thElements = tableRef.current.querySelectorAll("thead th");
    const startWidth = parseInt(thElements[colIndex].offsetWidth, 10);

    const handleDrag = (e) => {
      const newWidth = startWidth + (e.clientX - startX);
      if (newWidth > 50) {
        setVisibleColumns((prevCols) => {
          const updated = [...prevCols];
          const selectedCols = updated.filter(col => col.selected);
          const selectedIndex = selectedCols.findIndex((_, idx) => idx === colIndex);
          const globalIndex = updated.findIndex((col, idx) => col.selected && idx === selectedIndex);

          if (globalIndex !== -1) {
            updated[globalIndex] = {
              ...updated[globalIndex],
              width: `${newWidth}px`,
            };
          }

          return updated;
        });
      }
    };

    const stopDrag = () => {
      window.removeEventListener("mousemove", handleDrag);
      window.removeEventListener("mouseup", stopDrag);
    };

    window.addEventListener("mousemove", handleDrag);
    window.addEventListener("mouseup", stopDrag);
  };

  const renderTableHeader = () => {
    const selectedColumns = visibleColumns.filter(col => col.selected);

    return selectedColumns.map((col, index) => (
      <th
        key={index}
        onClick={col.key === "settings" ? () => setcolumeConfModal(true) : undefined}
        style={{
          width: col.width,
          minWidth: col.width,
          position: 'relative',
          userSelect: 'none',
        }}
      >
        {col.key === "settings" ? <GetIcon iconName="IoSettingsOutline" size={13} /> : col.name}

        {col.key !== "settings" && (
          <div
            onMouseDown={(e) => initResize(e, index)}
            style={{
              position: 'absolute',
              right: 0,
              top: 0,
              height: '100%',
              width: '5px',
              cursor: 'col-resize',
              zIndex: 10,
            }}
          />
        )}
      </th>
    ));
  };

  const renderTableRow = (rowData, rowIndex) => {
    const globalIndex = indexOfFirstRow + rowIndex;

    return visibleColumns
      .filter(col => col.selected)
      .map((col, colIndex) => {
        const key = col.key;

        if (key === "sno") {
          return <td key={colIndex}>{globalIndex + 1}</td>;
        }

        if (key === "settings") {
          return (
            <td key={colIndex}>
              <span onClick={() => openEditModal(rowData, rowIndex)}>
                <GetIcon iconName="MdOutlineEdit" size={15} />
              </span>
            </td>
          );
        }

        if (["rejected_qty", "expiry_date", "manufacturing_date"].includes(key)) {
          return (
            <td key={colIndex}>
              <input
                type={key.includes("date") ? "date" : "text"}
                className="form-control noborder"
                style={{
                  height: '30px',
                  textAlign: 'center',
                  fontSize: '0.8rem',
                  background: 'transparent'
                }}
                value={rowData[key] || ""}
                onChange={(e) => handleInputChange(rowIndex, key, e.target.value)}
              />
            </td>
          );
        }

        return (
          <td key={colIndex}>
            <p className="mb-0">
              {["amount", "rate"].includes(key) ? `₹${rowData[key]}` : rowData[key]}
            </p>
          </td>
        );
      });
  };

  return (
    <>
      <table
        className="table table-bordered"
        ref={tableRef}
        style={{
          borderCollapse: 'separate',
          borderSpacing: '0px',
          tableLayout: 'fixed',
          width: '100%',
        }}
      >
        <thead className="tableHead1">
          <tr>{renderTableHeader()}</tr>
        </thead>
        <tbody>
          {currentRows.map((row, index) => (
            <tr key={index} className={getRowColor()} style={{ height: '30px', verticalAlign: 'middle' }}>
              {renderTableRow(row, index)}
            </tr>
          ))}
        </tbody>
      </table>

      {row.Rows.length > 10 && (
        <div className="d-flex justify-content-between align-items-center centerpagination">
          <Pagination
            setCurrentPage={setCurrentPage}
            pageSize={rowsPerPage}
            totalrecords={row.Rows.length}
            currentPage={currentPage}
          />
          <div>
            <span className="px-2" style={{ fontSize: '12px', color: '#270B79', position: 'relative', top: '-6px' }}>
              Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, row.Rows.length)} of {row.Rows.length} entries
            </span>
          </div>
        </div>
      )}

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default Table;
